import React from 'react';
import bem from '../../../utils/bem';
import FormField from '../../Atoms/FormComponents/FormField';
import useDebounce from '../../../hooks/useDebounce';
import useJobSearchAutocompleteValues from '../../../hooks/useJobSearchAutocompleteValues';
import Button from '../../Atoms/Button';

const JobsListingHeader = ({
  filtersConfig = {},
  filtersState,
  setFiltersState,
  queryPlaceHolder,
  filtersAnalyticsData,
  clearAllCallback,
}) => {
  const topFilters = filtersConfig || {};
  const baseClass = 'sgna-job-listing__header';
  const debouncedSearchTerm = useDebounce(filtersState.query, 500);
  const autocompleteResultsList = useJobSearchAutocompleteValues(
    filtersState.query,
    debouncedSearchTerm,
  );
  const isFilters =
    filtersState?.query ||
    filtersState?.field_country ||
    filtersState?.field_city ||
    filtersState?.field_state ||
    filtersState?.field_job_function ||
    filtersState?.field_target_profile;

  return (
    <>
      <div className={bem(baseClass, [], '', ['flex'])}>
        {topFilters.map((field) => {
          const state = filtersState;
          const setState = setFiltersState;
          let fieldConfig = field;
          if (field.name === 'query') {
            fieldConfig = {
              ...field,
              ...(queryPlaceHolder ? { placeholder: queryPlaceHolder } : {}),
            };
          }
          return (
            <div className="sgna-job-listing__item">
              <FormField
                fieldConfig={fieldConfig}
                state={state}
                setState={setState}
                key={`${field.type}-${field.name}`}
                {...field}
                children={field.name === 'query' && autocompleteResultsList}
                analyticsData={filtersAnalyticsData}
              />
            </div>
          );
        })}
      </div>
      <Button
        mods={['m', 'primary', 'clear-filters']}
        extra={[!isFilters ? 'disabled' : '']}
        onClick={clearAllCallback}
      >
        Clear Filters
      </Button>
    </>
  );
};

export default JobsListingHeader;
